import { AlertCircle } from 'lucide-react'

export function RegulatoryNotice() {
  return (
    <div className="rounded-lg border border-primary/20 bg-primary/10 p-4">
      <div className="flex items-start gap-3">
        <AlertCircle className="mt-0.5 h-5 w-5 text-primary" />

        <div>
          <h3 className="font-medium text-header-foreground">
            Cumplimiento Regulatorio
          </h3>

          <p className="mt-1 text-sm text-muted-foreground">
            Todos los registros deben conservarse por al menos 5 años según la
            normativa COFEPRIS. Asegúrese de exportar y respaldar estos
            reportes regularmente.
          </p>
        </div>
      </div>
    </div>
  )
}